import React, {Component} from 'react';
import {Button, Input, Table} from 'reactstrap';
import {toast} from 'react-toastify';
import moment from 'moment';
import DatePicker from 'react-datepicker';

import ErrorMsg from "../common/ErrorMsg";
import loadingGIF from "../../public/assets/images/loading.gif";
import StaffDasboardService from "../../services/StaffDasboardService";
import { PENDING, UPDATED } from './Constants';


const headingNameList = [
    'first_heading', 'second_heading', 'third_heading', 'forth_heading', 'fifth_heading'
];
const oldHeadingNameList = [
    'old_first_heading', 'old_second_heading', 'old_third_heading', 
    'old_forth_heading', 'old_fifth_heading'
];
const newHeadingNameList = [
    'new_first_heading', 'new_second_heading', 'new_third_heading', 
    'new_forth_heading', 'new_fifth_heading'
];
const emptyRequestData = {
    id: 0,
    user_achievement: 0,
    kpi_id: 0,
    added_on: '',
    first_heading: '',
    second_heading: '',
    third_heading: '',
    forth_heading: '',
    fifth_heading: '',
    request_note: ''
};

export default class CorrectionForm extends Component {
    state = {
        requestData: {...emptyRequestData},
        headings: [],
        addedOn: '',
        isLoading: false
    };

    componentDidMount = () => {
        this.getInitialState();
    };

    getInitialState = async () => {
        const {request} = this.props;
        this.setState({isLoading: true});
        try {
            let result = await StaffDasboardService.getKPIHeadings(request.kpi_id);
            if (200 === result.status) {
                let headings = result.data.kpi_headings.map((heading) => ({...heading}));
                this.setState({headings});
            }
        } catch (error) {
            console.log(error);
        }
        this.setState({
            requestData: {...request},  
            addedOn: moment(request.added_on, "MM/DD/YYYY")
        });
        this.setState({isLoading: false});
        return false;
    };

    handleChange = (e) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;
        let requestData = {...this.state.requestData};
        requestData[name] = value;
        this.setState({requestData});
    };

    handleDateChangeRaw = (event) => {
        event.preventDefault();
    };

    handleDateChange = (date, field) => {
        if (field === "addedOn") {
            // let requestData = {...this.state.requestData};
            // requestData['added_on'] = date;
            this.setState({addedOn: date});
        }
    };

    approveRequest = async () => {
        this.setState({isLoading: true});
        if (this.isValidRequest()) {
            let requestData = {...this.state.requestData};
            requestData['added_on'] = moment(this.state.addedOn).format("YYYY-MM-DD");
            const {userListData, correctionDataList} = this.props.staffData;
            let selectedUser = {...this.props.selectedUser};
            try {
                await this.props.putCorrectionApprove(
                    selectedUser.id, requestData, correctionDataList, userListData
                );
                
                let newRequestData = {...emptyRequestData};
                this.setState({requestData: newRequestData});
                this.props.setRefreshStatus(true);
                toast.success("Updated Successfully.");
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
        this.setState({isLoading: false});
        return false;
    };

    isValidRequest = () => {
        const {headings, requestData} = this.state;
        const {request} = this.props;
        let isError = false;
        let errorList = [
            <label key={-1} className="mb-2">
                Please provide the data for the heading
            </label>
        ];
        headings.map((heading, index) => {
            let headingName = '', oldHeadingName = '';
            if (index < 5) {
                headingName = headingNameList[index];
                oldHeadingName = oldHeadingNameList[index];
            }
            
            if (request[oldHeadingName] && !requestData[headingName]) {
                errorList.push(
                    <p key={index} className="mt-0 mb-1 text-center">
                        {heading.heading}
                    </p>
                );
                isError = true;
            }
        });
        if (isError) {
            let errorMsg = <div>{errorList}</div>
            toast.error(errorMsg, {autoClose: 5000});
        }
        return !isError;
    }

    deleteRequest = async () => {
        this.setState({isLoading: true});
        let requestData = {...this.state.requestData};
        const {userListData, correctionDataList} = this.props.staffData;
        let selectedUser = {...this.props.selectedUser};
        try {
            await this.props.deleteCorrectionRequest(
                selectedUser.id, requestData.id, correctionDataList, userListData
            );
            
            let newRequestData = {...emptyRequestData};
            this.setState({requestData: newRequestData});
            this.props.setRefreshStatus(true);
            toast.success("Deleted Successfully.");
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
        this.setState({isLoading: false});
        return false;
    };

    render() {
        const {requestData, headings, addedOn, isLoading} = this.state;
        const {request, staffDashboard, canEdit, canDelete} = this.props;
        let headingList = [], dataList1 = [], dataList2 = [], dataList3 = [];
        let noOfHeadings = headings.length;
        headings.map((heading, index) => {
            let headingName = '', oldHeadingName = '', newHeadingName = '';
            if (index < 5) {
                headingName = headingNameList[index];
                oldHeadingName = oldHeadingNameList[index];
                newHeadingName = newHeadingNameList[index];
            }
            headingList.push(
                <th className="border-0 font-weight-bold font-16 pl-3" 
                    key={heading.id}
                >
                    {heading.heading}
                </th>
            );
            dataList1.push(
                <td key={index} className="border-0 align-middle">
                    { heading.has_drop_down_enable && heading.drop_down_items.length > 0 ?
                        <select name={oldHeadingName} className="form-control" 
                            value={request[oldHeadingName]} disabled={true}
                        >
                            <option value={''}></option>
                            {heading.drop_down_items.map(item => 
                                <option key={item.id} value={item.item}>{item.item}</option>
                            )}
                        </select>
                        : 
                        <input name={oldHeadingName} type="text" className="form-control" 
                            value={request[oldHeadingName]} disabled={true} 
                        />
                    }
                </td>
            );
            dataList2.push(
                <td key={index} className="align-middle">
                    { heading.has_drop_down_enable && heading.drop_down_items.length > 0 ?
                        <select name={headingName} className="form-control" 
                            onChange={this.handleChange} 
                            value={request.status === PENDING ? 
                                requestData[headingName] : request[headingName]
                            }
                            disabled={request.status !== PENDING || staffDashboard}
                        >
                            <option key={0} value={''}>---Select---</option>
                            {heading.drop_down_items.map((item, ind) => 
                                <option key={ind} value={item.item}>{item.item}</option>
                            )}
                        </select>
                        : 
                        <input name={headingName} type="text" className="form-control" 
                            onChange={this.handleChange} 
                            value={request.status === PENDING ? 
                                requestData[headingName] : request[headingName]
                            } 
                            disabled={request.status !== PENDING || staffDashboard}
                        />
                    }
                </td>
            );
            dataList3.push(
                <td key={index} className="align-middle">
                    { heading.has_drop_down_enable && heading.drop_down_items.length > 0 ?
                        <select name={newHeadingName} className="form-control" 
                            disabled={true} value={request[newHeadingName]}
                        >
                            <option value={''}></option>
                            {heading.drop_down_items.map((item, ind) => 
                                <option key={ind} value={item.item}>{item.item}</option>
                            )}
                        </select>
                        : 
                        <input name={newHeadingName} type="text" className="form-control" 
                            disabled={true} value={request[newHeadingName]} 
                        />
                    }
                </td>
            );
        });

        return (
            <div className="position-relative">
                <Table responsive className="mb-0 bg-white" size="sm">
                    <thead>
                        <tr>
                            <th className="border-0 reqH1 font-weight-bold font-16"></th>
                            <th className="border-0 reqH2 font-weight-bold font-16 pl-3">
                                Date
                            </th>
                            {headingList}
                        </tr>
                    </thead>
                    <tbody>
                        <tr></tr>
                        <tr>
                            <td className="border-0 align-middle font-weight-bold">
                                Initial Record
                            </td>
                            <td className="border-0 align-middle  font-weight-bold">
                                <input type="text"  
                                    className="form-control" 
                                    value={request.old_date} 
                                    disabled={true} 
                                />
                            </td>
                            {dataList1}
                        </tr>
                        <tr>
                            <td className="align-middle font-weight-bold">
                                Requested Change
                            </td>
                            <td className="align-middle font-weight-bold">
                                <div className="div-datepicker">
                                    <DatePicker
                                        selected={addedOn}
                                        onChangeRaw={this.handleDateChangeRaw}
                                        onChange={(event) => this.handleDateChange(
                                            event, "addedOn")}
                                        dateFormat="MM/DD/YYYY"
                                        fixedHeight
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        className="form-control"
                                        minDate={moment('2012-01-01')}
                                        maxDate={moment().add(5, 'years')}
                                        autoComplete="off"
                                        disabled={request.status !== PENDING || staffDashboard} 
                                    />
                                </div>
                            </td>
                            {dataList2}
                        </tr>
                        <tr></tr>
                        <tr>
                            <td className="border-0 align-middle font-weight-bold">
                                Note
                            </td>
                            <td className="border-0 align-middle" 
                                colSpan={
                                    request.status === PENDING && !staffDashboard ? 
                                        noOfHeadings : noOfHeadings + 1
                                }
                            >
                                <Input type="textarea" name="request_note" rows="2" 
                                    value={request.status === PENDING ? 
                                        requestData.request_note : request.request_note
                                    } 
                                    onChange={this.handleChange} 
                                    disabled={request.status !== PENDING || staffDashboard} 
                                />
                            </td>
                            {request.status === PENDING && !staffDashboard &&
                                <td className="border-0 align-middle">
                                    {canEdit &&
                                        <Button className='btn btn-success' 
                                            onClick={this.approveRequest}
                                            disabled={isLoading}
                                        >Update Record</Button>
                                    }
                                    <i className="px-2"></i>
                                    {canDelete &&
                                        <Button className='btn btn-danger' 
                                            onClick={this.deleteRequest}
                                            disabled={isLoading}
                                        >Delete Record</Button>
                                    }
                                </td>
                            }
                        </tr>
                        {request.status !== PENDING && 
                            <tr>
                                <td className="align-middle font-weight-bold">
                                    Final Record
                                </td>
                                {request.status === UPDATED ? 
                                    <React.Fragment>
                                        <td className="align-middle font-weight-bold">
                                            <input type="text"  
                                                className="form-control" 
                                                value={request.new_date} 
                                                disabled={true} 
                                            />
                                        </td>
                                        {dataList3}
                                    </React.Fragment>
                                    : <td className="align-middle" 
                                        colSpan={noOfHeadings + 1}
                                    >Record has been Deleted.</td>
                                }
                            </tr>
                        }
                    </tbody>
                </Table>
                {isLoading &&
                    <p className="loading-gif">
                        <img src={loadingGIF} alt="Loading..." width="32" height="32"/>
                    </p>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/staffData/CorrectionForm.js